import cn from "classnames";
import { useTranslation } from "next-i18next";
import ContentEditable from "react-contenteditable";

import s from "./TextEditor.module.scss";

const TextEditor = ({
  fieldName,
  fieldValue = "",
  onChange,
  onBlur,
  isEditing,
  onClick,
  ...props
}) => {
  const { t } = useTranslation(["common"]);

  const handleInput = (e) => {
    const value = e.target.value
      .replace(/(<([^>]+)>)/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/^\s+/g, "");

    if (onChange) {
      onChange({
        name: fieldName,
        value,
      });
    }
  };

  return (
    <div className={s.textEditor}>
      <div
        className={cn(
          s.tooltip,
          isEditing && s.focused,
          // fieldValue.length > maxLength && s.warning
        )}
      >
        {/* <icon className={i.edit} /> */}
        <div className={s.info}>
          {/* <div>{fieldName}</div> */}
          <div>
            {/* <span>{fieldValue.length}</span> / {maxLength} */}
            <span>{fieldValue.length}</span>
          </div>
        </div>
      </div>
      <div onClick={onClick}>
        <ContentEditable
          className={cn(s.contentEditable, !fieldValue && s.empty)}
          placeholder={`${t("enter")} ${fieldName}`}
          disabled={false}
          onBlur={onBlur}
          onChange={handleInput}
          html={fieldValue}
          {...props}
        />
      </div>
    </div>
  );
};

export default TextEditor;
